import { useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Pagination,
  PaginationItem,
} from '@mui/material';

import DomainsListItem from './DomainsListItem';
import FetchError from '../UI/fetch-error/FetchError';
import Loader from '../UI/loader/Loader';
import { TableHeadCell } from '../table-cells/TableCells';

import { PreviousPageIcon, NextPageIcon } from '../../PaginationIcons';

import {
  useGetAuthenticationQuery,
  useGetDomainsQuery,
} from '../../services/ADapi';

const DomainsList = () => {
  const [page, setPage] = useState(1);
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();

  const {
    data: domains = [],
    isError,
    isLoading,
  } = useGetDomainsQuery(user_id);

  const ITEMS_PER_PAGE = 5;
  const paginatedDomains = domains.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const pageHandler = (_e, value) => {
    setPage(value);
  };

  if (isError) {
    return <FetchError />;
  }

  if (isLoading && isError) {
    return (
      <Typography variant="h3" sx={{ pt: 3, pb: 3 }}>
        No Domains yet
      </Typography>
    );
  }

  return (
    <>
      <TableContainer>
        {isLoading ? (
          <Loader text="Please wait..." />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableHeadCell>Domains</TableHeadCell>
                <TableHeadCell>Groups</TableHeadCell>
                <TableHeadCell>Users</TableHeadCell>
                <TableHeadCell></TableHeadCell>
                <TableHeadCell></TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedDomains.map(
                ({ id, name, ad_users_count, groups_count }) => (
                  <DomainsListItem
                    key={id}
                    id={id}
                    domain={name}
                    groups={groups_count}
                    users={ad_users_count}
                  />
                )
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>

      {domains.length > ITEMS_PER_PAGE ? (
        <Grid container sx={{ justifyContent: 'flex-end', pt: 5 }}>
          <Pagination
            count={Math.ceil(domains.length / ITEMS_PER_PAGE)}
            page={page}
            onChange={pageHandler}
            renderItem={(item) => (
              <PaginationItem
                {...item}
                slots={{
                  next: NextPageIcon,
                  previous: PreviousPageIcon,
                }}
              />
            )}
          />
        </Grid>
      ) : null}
    </>
  );
};

export default DomainsList;
